<!--申请风险金-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
       <template v-slot:riskGrade="scope">
          <div v-for="item in riskLevel" :key="item.id">
            <span v-if="scope.row.riskGrade.toString() === item.value">{{ item.label }}</span>
          </div>
      </template>
        <template #toolbar="scope">
           <!-- <el-button icon="el-icon-upload2" type="text" size="mini" @click="downloadExcel(scope.row)"></el-button> -->
           <el-button type="text" size="mini" icon="el-icon-view" @click="view(scope.row)"></el-button>
          <el-button type="text" size="mini" icon="el-icon-edit" v-if="statusEdit(scope.row.billState)" @click="edit(scope.row)"></el-button>
            <!-- <el-popover
            :ref="scope.row.id"
            placement="top"
            width="220"
             v-if="scope.row.billState ===2"
          >
            <p>确定退回该该风险金单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row)">退回</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover> -->
           <!-- <el-popover
            :ref="scope.row.id"
            placement="top"
            width="180"
             v-if="statusUnAudit(scope.row.billState)"
          >
            <p>确定反审核该立项交付单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row, 5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover> -->
          <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusEdit(scope.row.billState)">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { addRisk, delRisk } from "@/api/bill/risk";
import {tableSataus} from '@/views/bill/mixins/status'
// import { downloadExcel} from "@/api/bill/contract"
import initDict from "@/mixin/initDict";
export default {
  name: "PartnerBudgetTask",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin,tableSataus,initDict],
  data() {
    return {
      tableHead: [
        {
          label: "单据编号",
          prop: "code",
        },
        {
          label: "项目号",
          prop: "projectCode",
          query: {
            type: "input"
          }
        },
        {
          label: "项目节点",
          prop: "milestonePlan",
          formatter: cur => { return cur ? (cur.bsMilestoneNode ?  cur.bsMilestoneNode.name :  '') : '' }
        },
        //  {
        //   label: "合同号",
        //   prop: "opportunities"
        // },
        {
          label: "申请金额",
          prop: "appliedAmount"
        },
        {
          label: "风险层级",
          prop: "riskGrade",
          slot: 'riskGrade'
        },
        {
          label: "申请原因",
          prop: "remark"
        },
        // {
        //   label: "提交日期",
        //   prop: "budget"
        // },
        {
          label: "状态",
          prop: "billState",
            formatter: (state) => {
              return this.statusName(state)
            }
        }
      ],
      riskLevel: []
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
     this.getDict("riskLevel").then(res => {
      this.riskLevel = res.data;
    });
  },
  methods: {
     // 导出
      // downloadExcel(data) {
      //   downloadExcel(data.id,'立项交付')
      // },
    dataTableBeforeInit() {
      this._url = "/risk";
      const params = { page: this.page, size: this.offset,};
      this._params = Object.assign(params, this._query);
      return true;
    },
    dynamicSearch() {},
     view(row) {
      // this.$router.push({path: "/bill/risk/form" ,query: { id: row.id,isEdit: 0}});
       this.$router.push({name: "RiskForm" ,params: { id: row.id,isEdit: 0 }})
    },
    add() {
      //  this.$router.push({path: "/bill/risk/form" ,query: {isEdit: 1}});
       this.$router.push({name: "RiskForm"})
    },
    edit(row) {
      // this.$router.push({path: "/bill/risk/form" ,query: { id: row.id,isEdit: 1}});
       this.$router.push({name: "RiskForm" ,params: { id: row.id,isEdit: 1 }})
    },
    audit(data) { // 审核
      console.log(data)
      // data.projectDelivery =
      this.updata({id: data.id,billState: 3});
      this.$nextTick(() => {
        this.$refs[data.id].doClose()
      })
    },
    reject(data, status = 4) {
      // 4 退回  5 反审核
     const obj = {id: data.id,billState: status}
      this.updata(obj);
      this.$nextTick(() => {
        this.$refs[data.id].doClose()
      })
    },
    updata(data) {
      addRisk(data).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: '操作成功',
            type: "success",
            duration: 2500
          });
          this.dataTableInit();
        }
      });
    },
    // 删除
    subDelete(id) {
      delRisk(id).then(res => {
        this.dataTableInit();
        this.$notify({
          title: "删除成功",
          type: "success",
          duration: 2500
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
